import {
  breakpointSizes,
  getBreakpointDown,
  styleConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button, {
  ButtonDesigns,
  ButtonTypes,
} from 'src/components/Button/Button'
import Occlusion from 'src/components/Occlusion/Occlusion'
import Trns from 'src/localization/Trns'
import { createSetIsTooltipPopupOpen } from 'src/redux/actions/app.actions'
import { selectTooltipPopupMessageFromState } from 'src/redux/selectors/app.selectors'
import { PopupFadeInAndExpand } from 'src/style/keyframeUtils'
import { css } from 'styled-components'

interface TooltipPopupProps {
  className?: string
}

const TooltipPopup: React.FC<TooltipPopupProps> = (
  props,
): React.ReactElement => {
  const tooltipPopupMessage = useSelector(selectTooltipPopupMessageFromState)

  const dispatch = useDispatch()

  return (
    <div
      className={props.className + 'abraaa'}
      css={css`
        position: fixed;
        z-index: 13;
        /* display: none; */
        justify-content: center;
        align-items: center;
        top: 0;
        width: 100vw;
        height: 100vh;
        overflow: scroll;

        ${getBreakpointDown(breakpointSizes.XSM)(css`
          display: flex;
        `)}
      `}
    >
      <Occlusion
        className={'occlusion'}
        isOpen
        onClick={(): void => {
          dispatch(createSetIsTooltipPopupOpen(false))
        }}
        fadeIn
      />
      <div
        css={css`
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;
          width: 100%;
          margin: 0px 10px;
          opacity: 0;
          pointer-events: none;

          ${getBreakpointDown(breakpointSizes.XSM)(css`
            /* @include popup-fade-in-and-expand; */
            ${PopupFadeInAndExpand()}
            opacity: 1;
            pointer-events: all;
          `)}
        `}
      >
        <div
          css={css`
            padding: 30px;
            background-color: ${styleConstants.colors.white};
            border-top-left-radius: ${styleConstants.borderRadius.box};
            border-top-right-radius: ${styleConstants.borderRadius.box};
          `}
        >
          {tooltipPopupMessage}
        </div>
        <div
          css={css`
            padding: 30px;
            background-color: ${styleConstants.colors.gray_lightest};
            margin-top: 1px solid ${styleConstants.colors.gray_light};
            border-bottom-left-radius: ${styleConstants.borderRadius.box};
            border-bottom-right-radius: ${styleConstants.borderRadius.box};
            display: flex;
            flex-direction: column;
          `}
        >
          <Button
            type={ButtonTypes.button}
            design={ButtonDesigns.designCta}
            text={<Trns source={'Dismiss'} />}
            onClick={(): void => {
              dispatch(createSetIsTooltipPopupOpen(false))
            }}
            big
          />
        </div>
      </div>
    </div>
  )
}

export default TooltipPopup
